module.exports = __webpack_public_path__ + "img/provider1.6dd88752.jpg";